module.exports = __webpack_public_path__ + "static/media/main.429bda9e.svg";